import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { MutationOption, queryClient } from "libs/react-query";
import * as BrmGql from "generated/graphql";
import * as KeyFactory from "./threat-group-query-key-factory";

export interface ISetThreatGroupIsNation {
  threatGroupId: string;
  isNation: string;
}

/**
 * Sets the isNation property for threat group
 *
 * @param {string} threatGroupId - uuid of the threat group
 * @param {string} isNation - isNation value
 */
export const setThreatGroupIsNation = ({ threatGroupId, isNation }: ISetThreatGroupIsNation) => {
  return Brm.threatGroupApi.setThreatGroupIsNationState(threatGroupId, { body: isNation });
};

export interface IUseSetThreatGroupIsNation {
  options?: MutationOption<typeof setThreatGroupIsNation>;
}

/**
 * Custom hook to change the isNation property of an existing threat group
 *
 * @param {object} options - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetThreatGroupIsNation = ({ options }: IUseSetThreatGroupIsNation = {}) => {
  return ReactQuery.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(KeyFactory.threatGroupKeys.all);
      queryClient.invalidateQueries(BrmGql.useGetThreatGroupsQuery.getKey());
    },
    ...options,
    mutationFn: setThreatGroupIsNation,
  });
};
